import { Field as RffField } from 'react-final-form';
import { RffFieldProps } from './FieldProps';
import * as React from 'react';
import {PropsWithChildren} from "react";

export const Field = <  FieldValue = any,
    T extends HTMLElement = HTMLElement,
    InputValue = FieldValue,>(props: PropsWithChildren<RffFieldProps>) => {
  const { children, ...restProps } = props;
  return <RffField<FieldValue, T, InputValue> {...restProps}>{children}</RffField>;
};

export default Field;
